import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./axiosAuthProvider";
import { BrowserRouter } from "react-router-dom";
import LoadingIndicator from "./components/molecules/LoadingIndicator";

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
    <LoadingIndicator />
  </BrowserRouter>
);
